import PropTypes from 'prop-types';
import React, { Component, Suspense } from 'react';
import APP from 'app';
import Constants from 'constants';
import { emitGlobalError, removeGlobalError } from 'actions/userActions';
import { connect } from "react-redux";
import { Router, Switch, Route } from 'react-router-dom';
import MasterLayout from 'components/Layout/MasterLayout';
import EmptyLoader from 'views/Global/Loaders/EmptyLoader';
import Error from '../Error/404';
import { getUserInfoData } from "../../actions/userInfoAction";
import configHelper from 'helper/Config/configHelper';
import themeDecorator from './../../services/decorator/whiteLabel/setThemeConfig';
import { createBrowserHistory } from 'history';
import GA from '../../helper/GA/GA';

const { defaultLogo = '' } = APP.Utils.getConfig();
const { logo = '' } = APP.Utils.fetchGlobal();
const history = createBrowserHistory();
const { initGa, GaPageView } = GA;

class Root extends Component {

    constructor(props) {
        super(props);
        this.performScopeBindings();
    }

    performScopeBindings() {
        APP.MessageBus.on(Constants.actions.ERROR_HANDLER.DISPLAY_ERROR_MESSAGE, this.triggerGlobalError, this);
        APP.MessageBus.on(Constants.actions.ERROR_HANDLER.HIDE_ERROR_MESSAGE, this.triggerRemoveGlobalError, this);
    }

    triggerRemoveGlobalError(payload) {
        this.props.removeGlobalError(payload);
    }

    triggerGlobalError(payload) {
        this.props.removeGlobalError(payload);
        this.props.emitGlobalError(payload);
    }

    componentWillMount() {
        themeDecorator();
    }
    componentDidMount() {
        initGa()
    }

    render() {
        const { router, routes, paths } = this.props,
            pathArr = window.location.pathname.split('/') || '';
        let path;
        if (pathArr[1] === '') {
            window.location.href = '/hotel';
        }
        if (2 < pathArr.length) {
            path = `${pathArr[1]}/${pathArr[2]}`;
        } else {
            path = window.location.pathname.split('/')[1];
        }
        const { userInfo = {} } = this.props;
        const { additionalInfo = {} } = userInfo;
        const { lurl = '' } = additionalInfo;
        return (
            <div className="wrapper p-R">
                <MasterLayout logoUrl={lurl ? lurl : APP.Utils.isWhitelabel() ? logo : defaultLogo}>
                    <Suspense fallback={<EmptyLoader />}>
                        <Router history={history}>
                            <Switch>
                                {paths.map((pathMap, i) => {
                                    if (path in routes) {
                                        if (pathMap != "") {
                                            const Component = routes[path];
                                            return <Component key={pathMap} {...this.props} />
                                        }
                                    } else {
                                        return <Route key={pathMap} component={Error} />
                                    }
                                })}
                            </Switch>
                        </Router>
                    </Suspense>
                </MasterLayout>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    removeGlobalError: (payload) => {
        dispatch(removeGlobalError(payload));
    },
    emitGlobalError: (payload) => {
        dispatch(emitGlobalError(payload));
    },
    getUserInfoData: () => {
        dispatch(getUserInfoData());
    }
});


const mapStateToProps = state => {
    const { userinfos = {} } = state;
    const { userInfo = {} } = userinfos
    return {
        ...state,
        userInfo,
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Root);
